import * as React from 'react';
import { useEffect } from 'react';
import { Assets, Product } from 'components/Catalog/Interfaces/List/IListResponse';
import Products from 'components/Catalog/Product/ListView/Products';
import { IGtmList } from 'components/SeoSuite/interfaces/IGtmEventDetail';
import { dispatchViewItemList } from 'components/SeoSuite/helpers/gtmEvents';
import { toGtmProducts } from 'components/SeoSuite/helpers/catalogProducts';

export interface ICrossSellProps {
    config: {
        assets: Assets;
        crossSellProducts: Product[];
    };
}

const CROSS_SELL_LIST: IGtmList = { id: 'cross_sell', name: 'Cross-sell products' };

const CrossSell = (props: ICrossSellProps) => {
    const { crossSellProducts, assets } = props.config;

    useEffect(() => {
        if (crossSellProducts?.length) {
            dispatchViewItemList(CROSS_SELL_LIST, toGtmProducts(crossSellProducts, CROSS_SELL_LIST));
        }
    }, [crossSellProducts]);

    return (
        <React.Fragment>
            <Products
                ignoreListView={true}
                products={crossSellProducts}
                inCartBlock={assets.inCartBlock}
                assets={assets}
                list={CROSS_SELL_LIST}
            />
        </React.Fragment>
    );
};

CrossSell.displayName = 'CrossSell';

export default CrossSell;
